/* eslint-disable no-console */
'use strict'

import Vue from 'vue'
import './../../plugins/vue-axios'

const state = {}
const getters = {}

const actions = {
  request: (store, options) => {
    return new Promise((resolve, reject) => {
      Vue.axios({ url: options.uri, ...options }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  actions
}
